import { FC } from 'react'
import LazyLoad from 'react-lazyload'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'
import CTASection from '~/components/TalentAI/CTASection'
import HeroSection from '~/components/TalentAI/HeroSection'
import OpportunitiesSection from '~/components/TalentAI/OpportunitiesSection'
import QuestionsToActionsSection from '~/components/TalentAI/QuestionsToActionsSection'
import TransparentAISection from '~/components/TalentAI/TransparentAISection'
import VisibilitySection from '~/components/TalentAI/VisibilitySection'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const TalentAIContainer: FC = () => {
  return (
    <LayoutLandingPage>
      <HeroSection />

      <LazyLoadWrapper height={300} once>
        <VisibilitySection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <OpportunitiesSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <QuestionsToActionsSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <TransparentAISection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <CTASection />
      </LazyLoadWrapper>
    </LayoutLandingPage>
  )
}

export default TalentAIContainer
